var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_728_21612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#39BFA9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9543 17.2209C31.9846 16.8181 32.0001 16.4112 32.0001 16.0006C32.0001 14.5319 31.7042 12.6845 31.3335 11.3333L26.6668 8L5.3335 25.3333L14.0002 32C23.3335 32.6667 29.2663 27.0341 31.2369 20.8973L31.2382 20.8895L31.4922 20.0006L31.744 18.8673C31.7455 18.859 31.747 18.8507 31.7485 18.8424L31.8684 18.0627C31.8711 18.0424 31.8736 18.022 31.8762 18.0015L31.9543 17.2209Z",
    fill: "#2EA894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.14 9.33398H6.79126V19.484H16.14V9.33398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4886 9.33398H16.1399V19.484H25.4886V9.33398Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.813 8.02148H5.33325V25.2053H26.813V8.02148ZM24.6651 12.3175L16.0732 17.6875L7.48123 12.3175V10.1695L16.0732 15.5394L24.6651 10.1695V12.3175Z",
    fill: "#54698E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8128 8H16.073V25.1839H26.8128V8ZM24.6649 12.296L16.073 17.6659V15.518L24.6649 10.148V12.296Z",
    fill: "#3C4F7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_728_21612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductEmailIcon);
export default __webpack_public_path__ + "static/media/product_email_icon.a7eb72e21078ba2cad28fffd9d6712b0.svg";
export { ForwardRef as ReactComponent };